import { navigate } from "../services";
import { ReducerState } from "./reducers";

export function isLoggedIn(user: ReducerState) {
    return user.size > 0;
}

export function isUserAdmin(user: ReducerState) {
    if (!isLoggedIn(user)) {
        return false;
    }

    return user.get("level") === "ADMIN";
}

export function authRedirect({
    user,
    locationState,
}: {
    user: ReducerState;
    locationState?: {
        from: {
            pathname: string;
        };
    };
}) {
    if (!isLoggedIn(user)) {
        return;
    }

    if (locationState) {
        const { pathname } = locationState.from;
        const nextPath = pathname === "/app/logout" ? "/app/docs" : pathname;
        navigate.redirectAfter(nextPath, 0.5);
    } else {
        navigate.redirectAfter("/app/docs", 0.5);
    }
}
